import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-calendar-activity',
  templateUrl: './calendar-activity.component.html',
  styleUrls: ['./calendar-activity.component.scss']
})
export class CalendarActivityComponent {
  @Input() activity = {
    id: 1,
    name: 'Complete CR Course',
    color: 'blue',
    status: 'NEW',
    time: 2,
    focus: false,
    isNonCourse: false
  }
  @Input() focus: boolean = false;

  @Input() isPending: boolean = false;

  isCementing = false;

  LottieStyles: Partial<CSSStyleDeclaration> = {
    width: '32px',
    height: '32px',
  };

  getClassOfActivity(){
    let class_name = '';
    switch(this.activity.color){
      case 'blue':
        class_name = this.activity.isNonCourse?'bg-blue':'bg-blue-light';
        break;
      case 'orange':
        class_name = this.activity.isNonCourse?'bg-orange':'bg-orange-light';
        break;
    }
    if(this.activity.status === 'COMPLETED' || this.activity.status == 'COMPLETED_AUTO'){
      class_name += ' completed ';
    }else{
      class_name += '';
    }
    if(this.focus || this.activity.time == 0){
      class_name += ' bg-gray';
    }
    return class_name;
  }

}
